// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reveal-panel {
    position: relative;
    min-height: 108px;
    overflow: hidden;
    background: var(--tp-surface);
}

.reveal-panel-content {
    min-height: inherit;
}

.reveal-panel-cover {
    position: absolute;
    inset: 0;
    z-index: 1;
    padding: 20px;
    display: flex;
    align-items: flex-end;
    background: var(--tp-mask);
    color: var(--tp-mask-text);
}

.reveal-panel-cover span {
    font-size: 12px;
    font-weight: 750;
}

@media (prefers-reduced-motion: no-preference) {
    .reveal-panel.is-revealed .reveal-panel-content {
        animation: reveal-content 360ms cubic-bezier(.16, 1, .3, 1) both;
    }
}

@keyframes reveal-content {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/components/public/RevealPanel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,aAAa;IACb,qBAAqB;IACrB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,gEAAgE;IACpE;AACJ;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":[".reveal-panel {\n    position: relative;\n    min-height: 108px;\n    overflow: hidden;\n    background: var(--tp-surface);\n}\n\n.reveal-panel-content {\n    min-height: inherit;\n}\n\n.reveal-panel-cover {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    padding: 20px;\n    display: flex;\n    align-items: flex-end;\n    background: var(--tp-mask);\n    color: var(--tp-mask-text);\n}\n\n.reveal-panel-cover span {\n    font-size: 12px;\n    font-weight: 750;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .reveal-panel.is-revealed .reveal-panel-content {\n        animation: reveal-content 360ms cubic-bezier(.16, 1, .3, 1) both;\n    }\n}\n\n@keyframes reveal-content {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
